import { Link } from 'react-router-dom';
import { AppIcon } from './AppIcon';

export function AppCard({ app }) {
  return (
    <article className={`app-card ${app.accent}`} key={app.slug}>
      <AppIcon app={app} />
      <p className="app-status">{app.status}</p>
      <h3>{app.name}</h3>
      <p>{app.tagline}</p>
      <div className="app-card-actions">
        <Link className="primary-action" to={`/apps/${app.slug}`}>Learn more</Link>
        {app.playUrl ? (
          <a className="secondary-action" href={app.playUrl} target="_blank" rel="noreferrer">Google Play</a>
        ) : null}
      </div>
    </article>
  );
}
